import { Component, OnInit, Inject } from '@angular/core';
import { Router } from "@angular/router";
import { BillingService } from "../../subscription/billing/billing.service";
import { BillingModel } from "../../subscription/billing/billing.model";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { CoreService } from '../../../core/header/core.service';
import { MatDialog } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import { UserBillingConst } from '../const';
import { Utils } from '../../../shared/utils';
import { consts } from '../../../consts';

@Component({
    selector: 'convfact-userbilling-list',
    templateUrl: './userbilling-list.component.html',
    styleUrls: ['./usercontact.component.css'],
    standalone: false
})
export class UserBillingListComponent implements OnInit {

  constructor(private billingService: BillingService, public snackBar: MatSnackBar, private coreService: CoreService,
    public dialog: MatDialog) { }

  dataSource: BillingModel[] = [];
  empty: boolean = false;
  ready: boolean = false;

  searchText: string;
  headerTable: any[] = UserBillingConst.headerTable;

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  pdf(uid: string): void {
    this.billingService.pdf(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetFileName("Suscripcion", consts.EXT_PDF));
    })
  }

  ngOnInit() {
    this.coreService.setName("Pago suscripciones");
    this.billingService.getList().then(
      data => {
        this.dataSource = data;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      }
    );
  }

}